import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import SalesNavigationDrawer from "../../../components/drawer/SalesNavigationDrawer/SalesNavigationDrawer";
import { AgreementsPage } from "../../../page/AgreementsPage";
import { AgreementPassportDialogPage } from "../../../page/AgreementsPage/AgreementPassportDialog/AgreementPassportDialogPage";
import { BookingPage } from "../../../page/BookingPage";
import { ContactPage } from "../../../page/ContactPage/ContactPage";
import { CustomerPage } from "../../../page/CustomerPage";
import { ClientPassportWindowPage } from "../../../page/CustomerPage/ClientPassportWindowPage";
import { CounterpartyPassportWindowPage } from "../../../page/CustomerPage/CounterpartyPassportWindowPage";
import { DocumentsPage } from "../../../page/DocumentsPage/DocumentsPage";
import ExamplePage from "../../../page/ExamplePage";
import ExternalLoginPage from "../../../page/ExternalLoginPage";
import { InvestmentProspectPage } from "../../../page/InvestmentProspectPage/InvestmentProspectPage";
import LandingPage from "../../../page/LandingPage";
import { LeadsPage } from "../../../page/LeadsPage/LeadsPage";
import { NoAccessPage } from "../../../page/NoAccessPage/NoAccessPage";
import { OffersPage } from "../../../page/OffersPage";
import { OfferReadOnlyWindowPage } from "../../../page/OffersPage/OfferReadOnlyWindowPage";
import { PersonRepositoryPage } from "../../../page/PersonRepositoryPage/PersonRepositoryPage";
import { ProductsPage } from "../../../page/ProductsPage";
import { ProductPassportWindow } from "../../../page/ProductsPage/ProductPassportWindow/ProductPassportWindow";
import { SalesDraftsPage } from "../../../page/SalesDraftsPage/SalesDraftsPage";
import { SalesInvestmentPage } from "../../../page/SalesInvestmentPage/SalesInvestmentPage";
import { SalesLandingPage } from "../../../page/SalesLandingPage/SalesLandingPage";
import { SalesProductsPage } from "../../../page/SalesProductsPage/SalesProductsPage";
import { SalesSellersPage } from "../../../page/SalesSellersPage";
import { TaskPage } from "../../../page/TaskPage/TaskPage";
import AgreementOverduePaymentPage from "../../../page/AgreementOverduePaymentPage/AgreementOverduePaymentPage";
import LogoutRoute from "../../auth/LogoutRoute/LogoutRoute";
import MyHomeAuth from "../../auth/MyHomeAuth";
import PersistLogin from "../../auth/PersistLogin";
import RequiredAuth from "../../auth/RequiredAuth";
import NavigationDrawer, {
    NAVIGATION_DRAWER_TYPE_AGREEMENTS,
    NAVIGATION_DRAWER_TYPE_CLIENTS,
    NAVIGATION_DRAWER_TYPE_CONTACTS,
    NAVIGATION_DRAWER_TYPE_LEADS,
    NAVIGATION_DRAWER_TYPE_OFFERS,
    NAVIGATION_DRAWER_TYPE_PERSON_REPOSITORY,
    NAVIGATION_DRAWER_TYPE_PRODUCTS,
    NAVIGATION_DRAWER_TYPE_TASKS,
    NAVIGATION_DRAWER_TYPE_INVESTMENT_DOCS,
    NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL
} from "../../drawer/NavigationDrawer/NavigationDrawer";
import IsTestingAppWrapper from "../../wrapper/IsTestingAppWrapper/IsTestingAppWrapper";
import Layout from "../../wrapper/Layout";
import FilterRoute from "../FilterRoute/FilterRoute";
import RedirectLoginRoute from "../RedirectLoginRoute";
import { MarketingPanelLandingPage } from "../../../page/MarketingPanelLandingPage/MarketingPanelLandingPage";
import MaketingPanelNavigationDrawer from "../../drawer/MarketingPanelNavigationDrawer";
import MarketingPanelChannelsPage from "../../../page/MarketingPanelChannelsPage";
import { ChannelPassportWindowPage } from "../../../page/MarketingPanelChannelsPage/ChannelPassportWindow";
import LeadByLeadSourceChartPage from "../../../page/LeadByLeadSourceChartPage";
import LeadByLeadStatusChartPage from "../../../page/LeadByLeadStatusChartPage/LeadByLeadStatusChartPage";
import LeadByLeadStatusReasonPage from "../../../page/LeadByLeadStatusReasonChartPage";
import { InvestmentDocsPage } from "../../../page/InvestmentDocsPage/InvestmentDocsPage";
import { FinancialPanelLandingPage } from "../../../page/FinancialPanelLandingPage/FinancialPanelLandingPage";
import FinancialPanelBankPage from "../../../page/FinancialPanelBankPage/FinancialPanelBankPage";
import FinancialPanelBankingPage from "../../../page/FinancialPanelBankingPage/FinancialPanelBankingPage";
import FinancialPanelTransferInvestmentBillPage from "../../../page/FinancialPanelTransferInvestmentBillPage/FinancialPanelTransferInvestmentBillPage";
import FinancialPanelTransferIndividualBillPage from "../../../page/FinancialPanelTransferIndividualBillPage/FinancialPanelTransferIndividualBillPage";
import SalesProposalPage from "../../../page/SalesProposalsPage/SalesProposalsPage";
import ClauseSubscribePage from "../../../page/ClauseSubscribePage/ClauseSubscribePage";
import ClauseUnsubscribePage from "../../../page/ClauseUnsubscribePage/ClauseUnsubscribePage";
import ClausesAdminPanelPage from "../../../page/ClausesAdminPanelPage/ClausesAdminPanelPage";
import ClauseHistoryPage from "../../../page/ClausesHistoryPage/ClausesHistoryPage";
import InvoicingSymfoniaCodesPage from "../../../page/InvoicingSymfoniaCodesPage/InvoicingSymfoniaCodesPage";
import InvoicingInvoicesPage from "../../../page/InvoicingInvoicesPage/InvoicingInvoicesPage";
import InvoicingIndividualBillPage from "../../../page/InvoicingIndividualBillPage/InvoicingIndividualBillPage";
import InvoicingAgreementPage from "../../../page/InvoicingAgreementPage/InvoicingAgreementPage";
import LeadChannelEfficiencyReportPage from "../../../page/LeadChannelEfficiencyReportPage/LeadChannelEfficiencyReportPage";
import { ContactChannelReportPage } from "../../../page/ContactChannelReportPage/ContactChannelReportPage";

function Router() {
    return (
        <Routes>
            <Route element={<IsTestingAppWrapper />}>
                <Route element={<Layout />}>
                    <Route path="/external_login/" element={<ExternalLoginPage />} />
                    <Route element={<MyHomeAuth />}>
                        <Route element={<PersistLogin />}>
                            <Route element={<RequiredAuth />}>
                                <Route element={< ClauseSubscribePage/> } path="clauses-subscribe/"/>
                                <Route element={< ClauseUnsubscribePage/> } path="clauses-unsubscribe/"/>
                                {/* Landing Page - set as root path */}
                                <Route path="/" element={<LandingPage />} />
                                <Route path="/sales-manager/" element={<SalesLandingPage />} />
                                <Route
                                    element={
                                        <SalesNavigationDrawer extraDrawerTypes={[]}>
                                            <Outlet />
                                        </SalesNavigationDrawer>
                                    }
                                >
                                    <Route
                                        path="/sales-manager/investment-configuration"
                                        element={
                                            <FilterRoute pageName="investments">
                                                <SalesInvestmentPage pageName="investments" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/sales-manager/products"
                                        element={
                                            <FilterRoute pageName="sales-products">
                                                <SalesProductsPage pageName="sales-products" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/sales-manager/documents"
                                        element={
                                            <FilterRoute pageName="sales-products">
                                                <DocumentsPage pageName="sales-documents" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/sales-manager/investment_prospectus"
                                        element={
                                            <FilterRoute pageName="sales-investment-prospectus">
                                                <InvestmentProspectPage pageName="sales-investment-prospectus" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/sales-manager/drafts"
                                        element={
                                            <FilterRoute pageName="sales-drafts">
                                                <SalesDraftsPage pageName="sales-drafts" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/sales-manager/sellers"
                                        element={
                                            <FilterRoute pageName="sales-sellers">
                                                <SalesSellersPage pageName="sales-sellers" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route path="/sales-manager/proposals"
                                           element={
                                                <FilterRoute pageName="sales-proposals">
                                                    <SalesProposalPage pageName="sales-proposals" />
                                                </FilterRoute>
                                            }
                                     />
                                </Route>
                                <Route path="/marketing-panel/" element={<MarketingPanelLandingPage />} />
                                <Route
                                    element={
                                        <MaketingPanelNavigationDrawer extraDrawerTypes={[]}>
                                            <Outlet />
                                        </MaketingPanelNavigationDrawer>
                                    }
                                >
                                    <Route
                                        path="/marketing-panel/channels"
                                        element={
                                            <FilterRoute pageName="channels">
                                                <MarketingPanelChannelsPage pageName="channels" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/marketing-panel/lead-reports/lead_source/"
                                        element={
                                            <FilterRoute pageName="lead-source-report">
                                                <LeadByLeadSourceChartPage pageName="lead-source-report" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/marketing-panel/lead-reports/lead_status/"
                                        element={
                                            <FilterRoute pageName="lead-status-report">
                                                <LeadByLeadStatusChartPage pageName="lead-status-report" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/marketing-panel/lead-reports/lead_status_reason/"
                                        element={
                                            <FilterRoute pageName="lead-status-reason">
                                                <LeadByLeadStatusReasonPage pageName="lead-status-reason" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/marketing-panel/lead-reports/lead_channel_efficiency/"
                                        element={
                                            <FilterRoute pageName="lead-channel-efficiency">
                                                <LeadChannelEfficiencyReportPage pageName="lead-channel-efficiency" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/marketing-panel/contact_channel_report/"
                                        element={
                                            <FilterRoute pageName="contact-channel-report">
                                                <ContactChannelReportPage pageName="contact-channel-report" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/clauses-admin/"
                                        element={
                                            <FilterRoute pageName="clauses-admin">
                                                <ClausesAdminPanelPage pageName="clauses-admin" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/clauses-history/"
                                        element={
                                            <FilterRoute pageName="clauses-history">
                                                <ClauseHistoryPage pageName="clauses-history" />
                                            </FilterRoute>
                                        }
                                    />
                                </Route>
                                <Route
                                    path="/marketing-panel/channel-window/:id"
                                    element={<ChannelPassportWindowPage />}
                                />
                                
                                    <Route
                                        path="/agreements/passport/:id"
                                        element={<AgreementPassportDialogPage />}
                                    />
                                <Route
                                    element={
                                        <NavigationDrawer
                                            extraDrawerTypes={[
                                                NAVIGATION_DRAWER_TYPE_LEADS,
                                                NAVIGATION_DRAWER_TYPE_CLIENTS,
                                                NAVIGATION_DRAWER_TYPE_PERSON_REPOSITORY,
                                                NAVIGATION_DRAWER_TYPE_CONTACTS,
                                                NAVIGATION_DRAWER_TYPE_PRODUCTS,
                                                NAVIGATION_DRAWER_TYPE_TASKS,
                                                NAVIGATION_DRAWER_TYPE_OFFERS,
                                                NAVIGATION_DRAWER_TYPE_AGREEMENTS,
                                                NAVIGATION_DRAWER_TYPE_INVESTMENT_DOCS,
                                            ]}
                                        >
                                            <Outlet />
                                        </NavigationDrawer>
                                    }
                                >
                                    <Route
                                        path="/example/"
                                        element={
                                            <FilterRoute pageName="example">
                                                <ExamplePage pageName="example" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/leads/"
                                        element={
                                            <FilterRoute pageName="leads">
                                                <LeadsPage pageName="leads" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/customers/"
                                        element={
                                            <FilterRoute pageName="customers">
                                                <CustomerPage pageName="customers" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/customers/passport-window/:id"
                                        element={<ClientPassportWindowPage />}
                                    />
                                    <Route
                                        path="/companies/passport-window/:id"
                                        element={<CounterpartyPassportWindowPage />}
                                    />
                                    <Route
                                        path="/persons/"
                                        element={
                                            <FilterRoute pageName="persons">
                                                <PersonRepositoryPage pageName="persons" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/contacts/"
                                        element={
                                            <FilterRoute pageName="contacts">
                                                <ContactPage pageName="contacts" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/products/"
                                        element={
                                            <FilterRoute pageName="products">
                                                <ProductsPage pageName="products" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/products/passport-window/:productId"
                                        element={<ProductPassportWindow />}
                                    />
                                    <Route
                                        path="/bookings/"
                                        element={
                                            <FilterRoute pageName="bookings">
                                                <BookingPage pageName="bookings" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route path="/tasks/" element={<TaskPage pageName="tasks" />} />
                                    <Route
                                        path="/offers/"
                                        element={
                                            <FilterRoute pageName="offers">
                                                <OffersPage pageName="offers" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/offers/preview/:offerId"
                                        element={<OfferReadOnlyWindowPage />}
                                    />
                                    <Route
                                        path="/agreements/"
                                        element={
                                            <FilterRoute pageName="agreements">
                                                <AgreementsPage pageName="agreements" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/agreement-overdue-payments/"
                                        element={
                                            <FilterRoute pageName="agreement-overdue-payments">
                                                <AgreementOverduePaymentPage pageName="agreement-overdue-payments" />
                                            </FilterRoute>
                                        }
                                    />       
                                    <Route
                                        path="/investment-docs"
                                        element={
                                            <FilterRoute pageName="investment-docs">
                                                <InvestmentDocsPage pageName="investment-docs" />
                                            </FilterRoute>
                                        }
                                    />
                                </Route>
                                <Route path="/financial-panel/" element={<FinancialPanelLandingPage />} />
                                <Route
                                    element={
                                        <NavigationDrawer
                                            drawerType={NAVIGATION_DRAWER_TYPE_FINANCIAL_PANEL}
                                        >
                                            <Outlet />
                                        </NavigationDrawer>
                                    }
                                >
                                    <Route path="/financial-panel/bank/" element={<FinancialPanelBankPage />} />
                                    <Route path="/financial-panel/banking/" element={<FinancialPanelBankingPage />} />
                                    
                                    <Route path="/financial-panel/transfer/investment_bills/"
                                           element={
                                                <FilterRoute pageName="transfer-investment-bills">
                                                    <FinancialPanelTransferInvestmentBillPage pageName="transfer-investment-bills" />
                                                </FilterRoute>
                                            }
                                     />
                                    <Route path="/financial-panel/transfer/individual_bills/" 
                                            element={
                                                <FilterRoute pageName="transfer-individual-bills">
                                                    <FinancialPanelTransferIndividualBillPage pageName="transfer-individual-bills" isWithdrawalPage={false} />
                                                </FilterRoute>
                                            }
                                     />
                                    <Route path="/financial-panel/transfer/individual_bills/withdrawal/" 
                                            element={
                                                <FilterRoute pageName="transfer-individual-bills-withdrawal">
                                                    <FinancialPanelTransferIndividualBillPage pageName="transfer-individual-bills-withdrawal" isWithdrawalPage={true}/>
                                                </FilterRoute>
                                            }
                                     />
                                    <Route
                                        path="/financial-panel/agreements/"
                                        element={
                                            <FilterRoute pageName="financial-panel-agreements">
                                                <AgreementsPage pageName="financial-panel-agreements" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/financial-panel/invoicing/symfonia_codes/"
                                        element={
                                            <FilterRoute pageName="financial-panel-invoicing-symfonia-codes">
                                                <InvoicingSymfoniaCodesPage pageName="financial-panel-invoicing-symfonia-codes" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route
                                        path="/financial-panel/invoicing/invoices/"
                                        element={
                                            <FilterRoute pageName="financial-panel-invoicing-invoices">
                                                <InvoicingInvoicesPage pageName="financial-panel-invoicing-invoices" />
                                            </FilterRoute>
                                        }
                                    />
                                    <Route path="/financial-panel/invoicing/investment_bills/"
                                           element={
                                                <FilterRoute pageName="invoicing-investment-bills">
                                                    <FinancialPanelTransferInvestmentBillPage pageName="invoicing-investment-bills" isInvoicingPage={true}/>
                                                </FilterRoute>
                                            }
                                     />
                                    <Route path="/financial-panel/invoicing/invoicing_individual_bills/"
                                           element={
                                                <FilterRoute pageName="invoicing-individual-bills">
                                                    <InvoicingIndividualBillPage pageName="invoicing-individual-bills" />
                                                </FilterRoute>
                                            }
                                     />
                                    <Route path="/financial-panel/invoicing/agreements/"
                                           element={
                                                <FilterRoute pageName="invoicing-agreements">
                                                    <InvoicingAgreementPage pageName="invoicing-agreements"/>
                                                </FilterRoute>
                                            }
                                     />
                                </Route>
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Route>

            <Route path="/no-access" element={<NoAccessPage />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/redirect_login/" element={<RedirectLoginRoute />} />
            <Route path="/logout/" element={<LogoutRoute />} />
            <Route
                path="/back_to_myhome/"
                element={<LogoutRoute navigateToRedirectBackToMyHomeRoute={true} />}
            />
            <Route
                path="/to_myhome_investment/"
                element={<LogoutRoute navigateToMyHomeInvestmentRoute={true} />}
            />
        </Routes>
    );
}

export default Router;
